import {connect} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import StoreListWhere from "../../../where/StoreListWhere";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as formatter from "../../../../../config/formatter";
import * as o2Api from "../../../../../api/api";
import "src/scss/grid-styles.scss";
import {Loading} from "../../../../../components/common";
import StoreCornerListWhere from "../../../where/StoreCornerListWhere";

const {RangePicker} = DatePicker;
const RejectReport = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [statData, setStatData] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [detailData, setDetailData] = useState([]);
    const [selected, setSelected] = useState({
        storeCd: "", storeNm: "", saleDt: ""
    });
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "",
        fromSaleDt: dayjs(), toSaleDt: dayjs()
    });

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [statColumnDefs] = useState([
        {field: "storeNm", headerName: "매장명", minWidth: 100},
        {
            headerName: "매출", children: [
                {
                    field: "totalBillCnt",
                    headerName: "건수",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "totalSaleAmt",
                    headerName: "금액",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        },
        {
            headerName: "반품", children: [
                {
                    field: "rejectBillCnt",
                    headerName: "건수",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "rejectSaleAmt",
                    headerName: "금액",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        },
        {
            headerName: "매출-반품", children: [
                {
                    field: "billCnt",
                    headerName: "건수",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "saleAmt",
                    headerName: "금액",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        }
    ]);

    const [columnDefs] = useState([
        {field: "saleDt", headerName: "판매일자", minWidth: 100, cellClass: "static-cell"},
        {
            headerName: "매출", children: [
                {
                    field: "totalBillCnt",
                    headerName: "건수",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "totalSaleAmt",
                    headerName: "금액",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        },
        {
            headerName: "반품", children: [
                {
                    field: "rejectBillCnt",
                    headerName: "건수",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "rejectSaleAmt",
                    headerName: "금액",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        },
        {
            headerName: "매출-반품", children: [
                {
                    field: "billCnt",
                    headerName: "건수",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
                {
                    field: "saleAmt",
                    headerName: "금액",
                    valueFormatter: formatter.currencyFormatter,
                    cellClass: "number-cell"
                },
            ]
        }
    ]);

    const [detailColumnDefs] = useState([
        {field: "posCd", headerName: "POS", minWidth: 50, cellClass: "static-cell"},
        {field: "billNo", headerName: "영수번호", minWidth: 80, cellClass: "static-cell"},
        {field: "tradeTypeNm", headerName: "구분", minWidth: 50, cellClass: "static-cell"},
        {field: "saleAmt", headerName: "총매출액", minWidth: 80, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "dcAmt", headerName: "총할인액", minWidth: 80, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "payAmt", headerName: "실매출액", minWidth: 80, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
    ]);

    useEffect(() => {

    }, []);

    const onGridReady = useCallback((params) => {
        // gridRef.current.api.sizeColumnsToFit();
    }, [])

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
            }));
        }
    }

    const search = () => {
        setError({
            visible: false,
            message: ""
        });

        const {cmpCd, brandCd, storeCd} = searchForm;
        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
        };

        props.setLoading(true);
        o2Api.getRejectSaleStats(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                props.setLoading(false);
                setStatData(responseBody);
            }
        });
    };

    const getRejectDailySale = (e) => {
        setError({
            visible: false,
            message: ""
        });

        const params = {
            cmpCd: e.cmpCd,
            brandCd: e.brandCd,
            storeCd: e.storeCd,
            fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
        };

        props.setLoading(true);
        o2Api.getRejectDailySale(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                props.setLoading(false);
                setGridData(responseBody);
            }
        });
    };

    const getRejectCurrentDaySale = (e) => {
        setError({
            visible: false,
            message: ""
        });

        const params = {
            cmpCd: e.cmpCd,
            brandCd: e.brandCd,
            storeCd: e.storeCd,
            fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
        };

        props.setLoading(true);
        o2Api.getRejectCurrentDaySale(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {
                props.setLoading(false);
                setDetailData(responseBody);
            }
        });
    };

    const onRowClicked1 = (e) => {
        if (!e.node.selected) return;

        console.log("### :: ", e);
        setSelected({
            storeCd: e.data.storeCd, storeNm: e.data.storeNm, saleDt: ""
        })
        getRejectDailySale(e.data);
    };

    const onRowClicked2 = (e) => {
        if (!e.node.selected) return;

        setSelected({
            storeCd: e.data.storeCd, storeNm: e.data.storeNm, saleDt: e.data.saleDt
        })
        getRejectCurrentDaySale(e.data);
    };

    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                    <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 80}}>기간</CInputGroupText>
                            <CInputGroupText style={{background: "white", height: 35}}>
                                <RangePicker bordered={false}
                                             separator={"~"}
                                             placeholder={""}
                                             locale={locale}
                                             value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
                                             onChange={(dayjs, dateString) => {
                                                 setSearchForm((state) => ({
                                                     ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
                                                 }));
                                             }}/>
                            </CInputGroupText>
                        </CInputGroup>
                    </CCol>
                    <div className={"d-grid d-lg-flex gap-1"}>
                        <CButton style={{minWidth: 50, height: 35}} size={"sm"} color="primary" onClick={search}>조회</CButton>
                    </div>
                </CForm>
                <div style={{height: 10}}/>
                <CRow>
                    <CCol xs={6}>
                        <CButton color={"primary"} style={{width: "100%", height: 35, textAlign: "start"}} size={"sm"} disabled={true}>매장별 반품현황</CButton>
                        <CRow>
                            <div className="ag-theme-alpine" style={{width: "100%", height: 250}}>
                                <AgGridReact
                                    ref={gridRef}
                                    onGridReady={onGridReady}
                                    rowSelection={"single"}
                                    headerHeight={30}
                                    rowHeight={30}
                                    rowData={statData}
                                    animateRows={true}
                                    onRowSelected={onRowClicked1}
                                    defaultColDef={defaultColDef}
                                    columnDefs={statColumnDefs}>
                                </AgGridReact>
                            </div>
                        </CRow>

                        <CButton color={"primary"} style={{width: "100%", height: 35, textAlign: "start", marginTop: 10}} size={"sm"} disabled={true}>{selected.storeNm}</CButton>
                        <CRow>
                            <div className="ag-theme-alpine" style={{width: "100%", height: 250}}>
                                <AgGridReact
                                    ref={gridRef}
                                    onGridReady={onGridReady}
                                    rowSelection={"single"}
                                    headerHeight={30}
                                    rowHeight={30}
                                    rowData={gridData}
                                    animateRows={true}
                                    onRowSelected={onRowClicked2}
                                    defaultColDef={defaultColDef}
                                    columnDefs={columnDefs}>
                                </AgGridReact>
                            </div>
                        </CRow>
                    </CCol>
                    <CCol xs={6}>
                        <CButton color={"primary"} style={{width: "100%", height: 35, textAlign: "start"}} size={"sm"} disabled={true}>일자 : {selected.saleDt}</CButton>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 545}}>
                            <AgGridReact
                                ref={gridRef}
                                onGridReady={onGridReady}
                                rowSelection={"single"}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={detailData}
                                animateRows={true}
                                defaultColDef={defaultColDef}
                                columnDefs={detailColumnDefs}>
                            </AgGridReact>
                        </div>
                    </CCol>
                </CRow>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(RejectReport);
